<!-- prettier-ignore -->
@if(datasource){
  <h3 
    class="hiking-title"
    (click)="goToCategoryListPage('hikings')"
  >
      <span>{{'Turismo activo' | translate}} >> </span>
  </h3>
  
  <div #eventContainer class="cardsScrollContainer items-scroll-wrapper">
    <span #leftArrow class="item-arrow-left eventGoLeft" scrollControl> < </span>
    <span #rightArrow class="item-arrow-right eventGoRight" scrollControl> > </span>

    <div class="viewport horizontal eventContainer" scrollControl>
        <div *uiScroll="let datasourceItem of datasource">
            <div class="item horizontal">
              @if(datasourceItem.type === 'item'){
                <cicerone-generic-card [item]="datasourceItem.data" />
              }    
            </div>
        </div>
    </div>
  </div>
}